import type { SocialMediaPlatform } from './SocialMedia.types';

import IGIcon from './assets/IG.png';
import TWIcon from './assets/TW.png';
import YTIcon from './assets/YT.png';
import SCIcon from './assets/SC.png';

export const SOCIAL_MEDIA_ICONS: Record<SocialMediaPlatform, string> = {
  instagram: IGIcon,
  twitter: TWIcon,
  youtube: YTIcon,
  soundcloud: SCIcon,
} as const;

export const SOCIAL_MEDIA_SIZES = {
  small: {
    iconSize: '32px',
    borderRadius: '8px',
    borderWidth: '2px',
  },
  medium: {
    iconSize: '64px',
    borderRadius: '16px',
    borderWidth: '4px',
  },
  large: {
    iconSize: '120px',
    borderRadius: '24px',
    borderWidth: '4px',
  },
} as const;

export const SOCIAL_MEDIA_ACCESSIBILITY = {
  LINK_TARGET: '_blank',
  LINK_REL: 'noopener noreferrer',
} as const;
